module.exports = __webpack_public_path__ + "img/icon_tempted.bc7212ca.svg";